import { Layout } from 'antd';
import { useEffect, useRef } from 'react';
import { Outlet, useBlocker } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { Header, ProcessingDataLoading, Sider } from '@/components';
import { useModalMethod } from '@/hooks/use-modal-method';
import { useCommonStore } from '@/store/common.store';

export function Features() {
  const {
    isFormChanged,
    isProcessing,
    setScrollTop,
    setIsFormChanged,
    setIsFormUpdated,
  } = useCommonStore(
    useShallow(
      ({
        isFormChanged,
        isProcessing,
        setScrollTop,
        setIsFormChanged,
        setIsFormUpdated,
      }) => ({
        isProcessing,
        isFormChanged,
        setScrollTop,
        setIsFormChanged,
        setIsFormUpdated,
      }),
    ),
  );
  const { confirm } = useModalMethod();
  const blocker = useBlocker(isFormChanged);
  const modalRef = useRef<ReturnType<typeof confirm> | undefined>(null);

  function contentRefCallback(node: HTMLDivElement) {
    if (!node) return;
    setScrollTop(() => {
      setTimeout(() => {
        node.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  useEffect(() => {
    if (blocker.state === 'unblocked' && modalRef.current) {
      modalRef.current.destroy();
      modalRef.current = undefined;
    }
  }, [blocker.state]);

  useEffect(() => {
    if (blocker.state === 'blocked' && !modalRef.current) {
      modalRef.current = confirm({
        okText: '移動する',
        title: '保存が完了していません。',
        content:
          'このページから離れると、入力中のデータは失われます。保存せず移動しますか？',
        onOk() {
          blocker.proceed?.();
          setIsFormChanged(false);
          setIsFormUpdated(true);
        },
        onCancel() {
          blocker.reset?.();
        },
      });
    }
  }, [blocker, confirm, setIsFormChanged, setIsFormUpdated]);

  return (
    <Layout>
      <Header />
      <Layout>
        <Sider />
        <Layout.Content ref={contentRefCallback}>
          {isProcessing && <ProcessingDataLoading />}
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
